<template>
  <div>
    <div v-if="!loading">
      <div>
        <defNavBar title="Ares - Show Whatsapp" :info="[
            {label: '', value: whap.whap_oms}, 
            {label: 'Sent: ', value: whap.whap_dt},
            {label: 'State: ', value: whap.whap_status},
            {label: 'Recipient: ', value: `${whap.whap_to} - ${whap.whap_to_recipient_desc} - ${whap.whap_to_recipient} (${whap.whap_to_waarde})`}]" />
            
      </div>
      <v-main> 
        <v-container fluid>
          <div v-html="content" class="whapcontainer" />
        </v-container>
      </v-main>
    </div>
    <div v-else class="spinner">
      <v-row>
        <v-col cols="12" span="12" align="center">
          <v-progress-circular :width="3" :size="25" color="green" indeterminate></v-progress-circular>
          <span class="markup ml-4">loading...</span>
        </v-col>
      </v-row>  
    </div>
  </div>
</template>


<script>
 import defNavBar from '@/components/ui/navbars/navbar.vue';
 export default {
  components: {
    defNavBar
  },
  props: ['whap_encrid'],
  data() {
    return {
      loading: true,
      whap: {},
      content: ''
    }
    
  },
  mounted() {
    this.loading=true;
    this.$axios
      .post("ares/json/ares/misc/getWhap.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getWhap"
        },
        getWhap: {
          whap_encrid: this.whap_encrid
       }
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
          this.loading = false; 
          document.querySelector(".spinner").classList.add('d-none');
        } else {
           this.whap = res.data.getWhap;
           console.log(this.whap);
           document.title = `Whatsapp message`;
           this.content = `${this.whap.whap_tekst}`;
           this.content = this.addCustomClassToImages();
           this.loading = false; 
           document.querySelector(".spinner").classList.add('d-none');
        }
      })
  },
  methods: {
    addCustomClassToImages() {
      // we need to add a global custom class to the image that will not affect other images. Name has to be unique
      const customClass = "_5c62376c-f59b-4836-997f-b2431fdfb8a6"
      return this.content.replace(/<img([^>]*)>/g, (match, attributes) => {
        let newAttributes = attributes.includes('class="') ? attributes.replace(/class="([^"]*)"/, `class="$1 ${customClass}"`) : `${attributes} class="${customClass}"`; 
        return `<img${newAttributes}>`;
      });      
    }    
  }
};

</script> 

<style scoped> 
.container {
  width: 100%; /* This will make it responsive to the mobile screen width */
  height: 80vh; /* Fills the entire viewport height */
  max-width: 400px; /* Restricts the maximum width to 400px, a common width for phones */
  margin: 20px auto 0; /* Centers the container */
  background-color: #ECE5DD; /* WhatsApp's default beige color */
  padding: 20px; /* Adds some padding inside the container */
  border-radius: 8px; /* Rounds the corners of the container */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Adds a subtle shadow for depth */
  overflow-y: auto; /* Adds vertical scrollbar if content overflows */
}
</style>

<style>
._5c62376c-f59b-4836-997f-b2431fdfb8a6 {
  max-width: 100% !important;
  height: auto !important;
}
</style>
